import Image from 'next/image';

import { maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

type Props = {
  trigger: Trigger;
  triggerType: EventTriggerType;
};

export const FogoTokenHoldersTriggerDetails = ({ trigger, triggerType }: Props) => {
  const tokenAddress = trigger.context?.token_address ?? '';
  const fogoExplorerUrl = `https://fogoscan.com/token/${tokenAddress}`;

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Contract"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/webp/fogo.webp" width={12} height={12} alt="Fogo" />
            <span>{maskAddressValue(tokenAddress)}</span>
          </div>
        }
        href={fogoExplorerUrl}
      />
    </div>
  );
};
